import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAhfBxDq3q8KDKFeMaVTqQAmt3pEkjSiKo",
  authDomain: "e-commerce-store-cwz.firebaseapp.com",
  projectId: "e-commerce-store-cwz",
  storageBucket: "e-commerce-store-cwz.appspot.com",
  messagingSenderId: "409906240700",
  appId: "1:409906240700:web:4ae30a41f4b85ecfb944b9",
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();

export const firestore = firebase.firestore();

export const storage = firebase.storage();

export default firebase;
